/**
 *  Controls - Table scrollbar - use as second scrollbar in data components
 * @returns {string} css class depends on user theme mode
 */
export const getTableScrollbar = () => {
    const isDark = window._getTheme() === 'dark';

    return isDark ? 'scroll-table-dark' : 'scroll-table-light'
};

